<template>
  <div class="yx-pagination">
    <el-pagination
        background
        layout="prev, pager, next, slot"
        :current-page.sync="current"
        :total="total"
        :page-size="size"
        :page-count="pagerCount"
        @current-change="handlerChange"
    >

    </el-pagination>
    <el-input class="yx-pagination-input" v-model="pageNum"></el-input>
    <el-button class="yx-pagination-btn" @click="handlerDumpPage">跳转</el-button>
    <p class="stat">共{{total}}条记录</p>
    <p class="stat">共{{totalPage}}页</p>
  </div>
</template>

<script>
export default{
  props:{
    size:{
      type: [Number],
      default: 0,
    },
    pagerCount:{
      type: [Number],
      default: 5,
    },
    total:{
      type: [Number],
      default: 0,
    },
    current:{
      type: [Number],
      default: 0,
    },
  },
  computed:{
    totalPage(){
      return Math.ceil(this.total / this.size);
    },
  },
  data(){
    return {
      pageNum: null,

    }
  },
  methods:{
    handlerDumpPage(){
      let pageNum = parseInt(this.pageNum);
      pageNum = pageNum < this.totalPage ? pageNum : this.totalPage;
      pageNum = pageNum > 1 ? pageNum : 1;
      this.handlerChange(pageNum);
    },
    handlerChange(page){
      this.$emit('change', page);
    }
  }
}
</script>

<style lang="less" scoped>
.yx-pagination{
  font-family: MicrosoftYaHei;
  display: flex;
  align-items: center;

  .el-pagination{
    display: flex;
    :deep(button){
      width: auto;
      height: 22px;
      padding: 5px 7px;
      background-color: #ffffff;
      border-radius: 4px;
      border: solid 1px #dddddd;
      font-size: 12px;
      line-height: 24px;
      color: #666666;
    }
    :deep(ul){
      display: flex;
      li{
        width: auto;
        height: 22px;
        font-size: 12px;
        padding: 6px 8px;
        background-color: #ffffff;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: solid 1px #dddddd;
        &.active{
          background-color: #f0413e;
          border-color: #f0413e;
        }
      }
    }
  }

  &-input{
    width: 50px;
    height: 22px;
    margin: 0 10px;
    background-color: #ffffff;
    border-radius: 4px;
    font-size: 12px;
    :deep(input){
      height: 22px;
    }
  }

  &-btn{
    width: 40px;
    height: 22px;
    background-color: transparent;
    border-radius: 4px;
    border: solid 1px #dddddd;
    font-size: 12px;
    line-height: 24px;
    display: flex;
    align-items: center;
    padding: 6px 7px;
    color: #666666;
    margin-right: 10px;
  }

  .stat{
    font-size: 12px;
    margin: 0 10px;
    line-height: 24px;
    color: #666666;
  }
}
</style>